import { render } from "./SportView.vue?vue&type=template&id=eb588c66"
import script from "./SportView.vue?vue&type=script&lang=js"
export * from "./SportView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__